import {r as w} from '@theme/theme-sections';
import {F as d} from '@theme/flickity';
import '@theme/_commonjsHelpers';
const l = {switcherSliderContainer: '[data-slider-switchers]', productSliderContainer: '[data-slider-products]'},
  g = 'fitguide-details';
var h, u, f;
const S =
    ((f = (u = (h = window.Shopify) == null ? void 0 : h.theme) == null ? void 0 : u.sections) == null
      ? void 0
      : f.registered) || {},
  m = typeof S[g] > 'u';
m &&
  w(g, {
    onLoad() {
      const s = this.container,
        c = window.location.hash.substring(1),
        n = document.querySelectorAll('.fit-guide-details__slide');
      for (let e = 0; e < n.length; e++) {
        const i = n[e];
        i.addEventListener('click', () => this.switchActive(i));
      }
      const o = s.querySelector(l.switcherSliderContainer);
      if (!o) return;
      const a = new d(o, {prevNextButtons: !1, pageDots: !0, adaptiveHeight: !1, fade: !1, watchCSS: !0, contain: !0});
      a.on('change', (e) => {
        this.switchActive(n[e]);
      });
      const r = s.querySelectorAll(l.productSliderContainer);
      if (r) {
        for (let e = 0; e < r.length; e++) {
          const i = r[e],
            t = new d(i, {
              prevNextButtons: !1,
              pageDots: !1,
              adaptiveHeight: !1,
              fade: !1,
              watchCSS: !0,
              cellAlign: 'center',
              contain: !0,
            });
          document.addEventListener('tabChange', () => {
            t.resize();
          });
        }
        if (c) {
          const e = document.querySelector(`[data-switcher-hash="${c}"]`),
            i = e.parentNode,
            p = Array.from(i.children).indexOf(e);
          this.switchActive(e), a.select(p);
        }
      }
    },
    switchActive(s) {
      const c = document.querySelectorAll('.fit-guide-details__slide'),
        n = document.querySelectorAll('.fit-guide-details__content-section'),
        o = document.querySelectorAll('.fit-guide-details__video-element'),
        a = s.getAttribute('data-switcher-content-id'),
        r = document.getElementById(a),
        e = s.getAttribute('data-switcher-hash');
      c == null ||
        c.forEach((t) => {
          t.classList.toggle('active', t === s);
        }),
        n == null ||
          n.forEach((t) => {
            t.classList.toggle('active', t === r);
          }),
        o == null ||
          o.forEach((t) => {
            t.pause();
          }),
        (window.location.hash = e);
      const i = new CustomEvent('tabChange');
      document.dispatchEvent(i);
    },
  });
